if (!customElements.get('product-recommendations')) {
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
      if (this.classList.contains('section')) {
        this.loader();
      }
      this.io = window.initLazyScript(this, this.init.bind(this), 500);
    }
  
    unobserve() {
      if (this.io) {
        this.io.unobserve(this);
      }
    }
  
    loader() {
      this.classList.add('loading');
      window.generateLoader(this);
  }

  async init() {
    const { productId } = this.dataset;
    if (!productId) return;

    try {
      const response = await fetch(`${this.dataset.url}&product_id=${productId}`);
      if (!response.ok) throw new Error(response.status);

      const tmpl = document.createElement('template');
      tmpl.innerHTML = await response.text();

      const el = tmpl.content.querySelector('product-recommendations');
      if (el && el.hasChildNodes()) {
        this.innerHTML = el.innerHTML;
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  
      window.removeLoader(this);
      this.classList.remove('loading');
  }
}

customElements.define('product-recommendations', ProductRecommendations);
}
